/**
 * Filter Bar Conditions
 */
export enum CONDITIONS {
  EQUAL = 'equals',
  NOT_EQUAL = 'does not equals',
  IS_SET = 'is set',
  IS_NOT_SET = 'is not set',
  GREATER_THAN = 'greater than',
  MINOR_THAN = 'minor than',
  IS_TRUE = 'is true',
  IS_FALSE = 'is false',
  MORE_THAN = 'more than',
  LESS_THAN = 'less than',
  WAS_MADE = 'was made',
  WAS_NOT_MADE = 'was not made',
  WAS_ON = 'was on',
  WAS_NOT_ON = 'was not on',
  WAS_AGO = 'was ago',
  WAS_NOT_AGO = 'was not ago',
  WAS_MORE_THAN = 'was more than',
  WAS_NOT_MORE_THAN = 'was not more than',
  WAS_LESS_THAN = 'was less than',
  WAS_NOT_LESS_THAN = 'was not less than',
  WILL_BE_IN = 'will be in',
  WITH_PROPERTY = 'with property',
  ANNIVERSARY_IS = 'anniversary is',
  CONTAINS = 'containts',
  SENT = 'sent',
  NOT_SENT = 'not sent',
  CLICKED = 'clicked',
  NOT_CLICKED = 'not clicked',
  CHANGED_VALUE = 'changed value',
  IS_IN_AUDIENCE = 'is in audience',
  IS_NOT_IN_AUDIENCE = 'is not in audience',
  ENGAGED = 'engaged',
  ATTRIBUTED = 'attributed',
  NONE = '',
}

/**
 * Filter Bar Boolean Operator
 */
export enum BOOLEAN_OPERATOR {
  AND = 'and',
  OR = 'or',
}

/**
 * Filter Bar Filter Operator
 */
export enum FILTER_OP {
  EQ = 'eq',
  NE = 'ne',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  IN = 'in',
  NIN = 'nin',
}
